export default __webpack_public_path__ + "static/media/ParisToNice.a0a9ea6c.webp";